import React from 'react';
export function CampaignAdIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M14 18.5l-1.5 1-2-3.5L8 18V9l7.5 5.5-3.5.5 2 3.5z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1h22v22H1V1zm2 3.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM3 8h18v13H3V8z"
  }));
}